<template>
  <div>
    <div id="mySidenav" class="sidenav" style="left: 0px;">
      <div class="card-header m-0 font-bold">
        Suchen und Filtern
      </div>
      <div id="sidebar" class="px-2 py-2">
        <div>
          <label class="formfont">Projektname, Nr, Ort:</label>
          <div class="col-12 input-group mb-3 p-0">
            <input placeholder="Projektname, Nr, Ort" data-on-color="success" type="text" name="name" required="required" class="form-control font12" v-model="filters.name">
          </div>
        </div>
        <div class="switch">
          <label class="w-100 formfont"> Ersteller:
<!--            <input type="checkbox" id="customSwitch1" class="custom-control-input" v-model="filters.creator" :true-value="1" :false-value="''">-->
<!--            <span class="lever float-right mr-0"></span>-->
          </label>
          <div class="col-12 input-group mb-3 p-0">
            <input placeholder="Ersteller" data-on-color="success" type="text" name="name" required="required" class="form-control font12" v-model="filters.creator">
          </div>
        </div>
        <div class="switch">
          <label class="w-100 formfont"> Status:
            <input type="checkbox" id="customSwitch1" class="custom-control-input" v-model="filters.status" :true-value="1" :false-value="''">
            <span class="lever float-right mr-0"></span>
          </label>
        </div>
      </div>
    </div>

    <div class="main-content main-customer font1rem minheight100">
      <!-- one tab -->
      <div class="conatiner-fluid d1" id="DataA">
        <div class="row">
          <div class="col-sm-12 pl-1 pr-1 py-2">

            <table class="w-100 table ">
              <thead>
              <tr>
                <th></th>
                <th>Projektname</th>
                <th>Kurzname</th>
                <th>Projekt-Nr.</th>
                <th>Ort</th>
                <th>Benutzer</th>
                <th>Erstellt am</th>
                <th>Ersteller</th>
                <th>Status</th>
              </tr>
              </thead>
              <tbody>

                <tr v-for="(item,index) in customerprojects">
                  <td><a href="#" @click="userlistmodal(item)"><i class="fa fa-circle-user"></i></a></td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.shortname }}</td>
                  <td>{{ item.number }}</td>
                  <td>{{ item.city }}</td>
                  <td :data-userids="item.userids"><a href="#" @click="userlistmodal(item)">{{ item.usercount }}</a></td>
                  <td>
                    {{ item.created |toDEDate()}}
                  </td>
                  <td>
                    {{ item.creator_obj.firstname }} {{ item.creator_obj.lastname }}
                  </td>
                  <td>
                    <div class="switch ">
                      <label class="">
                        <input type="checkbox" :id="'creator' + item.projectid" class="custom-control-input" v-model="item.status" :true-value="1" :false-value="0" @change="setCustomerProjectStatus($event, item)">
                        <span class="lever float-right mr-0"></span>
                      </label>
                    </div>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Userlist-Modal v-if="showusermodal" :projectitem="projectitem" @closeModal="showusermodal = false" :customerid="customerid"></Userlist-Modal>
  </div>
</template>
<script>

import axios from '../../../utils/axiosinstance'
// import axios from 'axios'
import UserlistModal from './UserlistModal.vue'
import moment from 'moment'

export default {
  name: 'projects',
  components: {UserlistModal},
  data () {
    return {
      'area': 'projects',
      'customerid': '',
      'showusermodal': false,
      customerprojects: [],
      projectitem: {},
      filters: {
        name: '',
        creator: '',
        status: ''
      }
    }
  },
  filters: {
    toDEDate: function(string) {
      return moment(string).format('DD.MM.YYYY HH:mm:ss')
    }
  },

  mounted () {
    this.customerid = this.$route.params.customerid
    console.log('PROJECTS MOUNTED')
    this.fixElementHeights()
    this.getCustomerProjects()
  },

  methods: {

    userlistmodal(item) {
      this.showusermodal = true
      this.projectitem = item


    },


    getdateadded(item) {
      let returndate = moment(item.added)
      if(!returndate.isValid()) {
        returndate = moment(item.created)
      }
      return returndate.format('DD.MM.YYYY')
    },

    fixElementHeights () {
      let headerheight = $('header').height()
      $('#mySidenav, .main-content').css({'top': headerheight})
      $('.main-content').css({'margin-left':'210px'})
      $('#mySidenav').css({'height':'calc(100vh - '+headerheight+'px)'});
      console.log('sidenavheight', headerheight)
    },

    async getCustomerProjects () {
      let _this = this
      console.log('get CustomerUserProjects', this.customerid)

      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [_this.customerid, _this.filters],
        serviceName: "ProjectdocuCustomer",
        methodName: "getcustomerprojects"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        _this.customerprojects = response.data.projects
      }).catch(e => {
        console.log('ERROR EXECUTION')
      });
    },
    async setCustomerProjectStatus (event, item) {
      console.log('ToDo: Set Customer Project Status', item, item.status)
      let _this = this
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [_this.customerid, item.projectid, item.status],
        serviceName: "ProjectdocuCustomer",
        methodName: "setCustomerProjectStatus"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        if(response.data == true) {
          _this.localtoast = _this.$toast(
            'Gespeichert.',
            {
              timeout: 2000,
              closeOnClick: true,
              toastClassName: "savenote",
            }
          )
        }
      }).catch(e => {
        console.log('ERROR EXECUTION')
      });
    },
  },

  watch: {
    filters: {
      handler (newData) {
        console.log('Filter', newData)
        this.getCustomerProjects();
      },
      deep: true
    }
  },
  created () {
    console.log('PROJECTS CREATED')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/customer/components/projects.vue